
import React, { useState } from "react"
import { FormattedMessage } from "react-intl"
import NewSchedulingPageModal from "../../../../../src/scheduling-page/newmodal.component.jsx"
import Icon from "../../../icon/icon.component.jsx"
import ButtonWrapper from "../../../rich-text/feature-protection-wrappers/buttonProtectionWrapper.component"
import { AccountFeatures } from "@lightspeed-invoicing/core-client/frontend"

const SchedulingPageCreationButton = () => {

    const [openModal, setOpenModal] = useState<boolean>(false)

    const handleOpenModal = () => {
        setOpenModal(true)
    }

    const handleCloseModal = (id?: string) => {
        setOpenModal(false)
        if (id) {
            window.location.href = `/scheduling-pages/${id}/edit`
        }
    }
    return (
        <>
            {openModal && (
                <NewSchedulingPageModal
                    onClose={handleCloseModal}
                />
            )}
            <ButtonWrapper
                onClick={handleOpenModal}
                className="btn btn-primary"
                protectedClassName="btn btn-primary"
                accountFeatureKey={AccountFeatures.FeatureScheduling}
            >
                <span>
                    <Icon value={"plus-circle"} />
                    <FormattedMessage
                        id="listing.search.scheduling_page_add_btn"
                        defaultMessage="New scheduling page"
                    />
                </span>
            </ButtonWrapper>
        </>
    )
}

export default SchedulingPageCreationButton


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/creation-buttons/SchedulingPageCreationButton.tsx